/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { CircularProgressbar } from 'react-circular-progressbar'
import { toast } from 'react-toastify'
import UiSelect from '../../../components/UI/UISelect'
import UIButton from '../../../components/UI/UIButton'

import { Accordion, AccordionItem } from '../components/Accordion'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import UIStaightlineProressBar from '../../../components/UI/UIStaightlineProressBar'
import { employmentDetails, employmentResponse } from '../../../utils/types'
import { useQuery } from 'react-query'
import {
  getProfileEmployment,
  updateProfileEmployment,
} from '../../../api/candidate/myscrApis'
import UIDatePickerv from '../../../components/UI/UIDatePickerv'
import UITextInput from '../../../components/UI/UITextInput'
import { calculateNonNullPercentage } from '../../../utils/utils'
import { Icon } from '../../../components/Icon'
import Modal from '../../../components/UI/UIModal'

type AnyObject = { [key: string]: any }
type AnyArray = any[]

function convertSpecificFieldsToUndefined(
  obj: AnyObject | AnyArray
): AnyObject | AnyArray | undefined {
  if (Array.isArray(obj)) {
    return obj.map(convertSpecificFieldsToUndefined)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc: AnyObject, key: string) => {
      if (key === 'department' || key === 'workStatus') {
        acc[key] = !obj[key] ? undefined : obj[key]
      } else {
        acc[key] = obj[key]
      }
      return acc
    }, {})
  } else {
    return obj
  }
}

const emptyData = [
  {
    jobTitle: '',
    // department: '',
    startDate: '',
    endDate: '',
    // workStatus: '',
  },
  {
    jobTitle: '',
    // department: '',
    startDate: '',
    endDate: '',
    // workStatus: '',
  },
  {
    jobTitle: '',
    // department: '',
    startDate: '',
    endDate: '',
    // workStatus: '',
  },
]
const Employment = () => {
  const divRef = useRef<HTMLDivElement>(null)
  const [alertActive, setAlertActive] = useState(false)
  const [isOpenAlert, setIsOpenAlert] = useState(false)
  const [userData, setUserData] = useState<employmentDetails[]>()
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)

  const getProfileData = async (): Promise<employmentDetails[]> => {
    const response = (await getProfileEmployment()) as employmentResponse
    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const { data, isLoading, isError, refetch } = useQuery(
    'userEmployment',
    getProfileData
  )

  const handleChange = (
    objNo: number,
    fieldName: keyof employmentDetails,
    value: string
  ) => {
    setAlertActive(true)
    setUserData((prevUserData) => {
      return (
        prevUserData &&
        prevUserData?.map((obj, index) => {
          if (index === objNo - 1) {
            return { ...obj, [fieldName]: value }
          }
          return obj
        })
      )
    })
  }

  useEffect(() => {
    if (data?.length != 0) {
      const updatedData = convertSpecificFieldsToUndefined(data as any)
      setUserData(updatedData as any)
    } else {
      setUserData(emptyData as any)
    }
  }, [data])

  const updateProfileData = async (
    values: employmentDetails[]
  ): Promise<void> => {
    setIsUpdateLoading(true)
    try {
      const response = (await updateProfileEmployment(values)) as {
        status?: string
        data: employmentDetails
      }
      if (response?.status === 'successful') {
        refetch()
        toast.success('Profile Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error(
        'Please make sure all fields are filled correctly before updating.',
        { position: 'top-right' }
      )
    } finally {
      setIsUpdateLoading(false)
    }
  }

  const propertiesToCheck = [
    userData && userData[0]?.jobTitle,
    userData && userData[0]?.department,
    userData && userData[0]?.startDate,
    userData && userData[0]?.endDate,
    userData && userData[0]?.workStatus,
    userData && userData[1]?.jobTitle,
    userData && userData[1]?.department,
    userData && userData[1]?.startDate,
    userData && userData[1]?.endDate,
    userData && userData[1]?.workStatus,
  ]

  const handleClickOutside = (event: MouseEvent) => {
    if (
      divRef.current &&
      !divRef.current.contains(event.target as Node) &&
      alertActive
    ) {
      setIsOpenAlert(true)
    } else if (isOpenAlert == false) {
      setAlertActive(false)
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [alertActive])

  return (
    <div
      ref={divRef}
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-5 '
      }
    >
      <div
        style={{
          // height: 'calc(100vh - 100px)',
          overflow: 'auto',
          // scrollbarWidth: 'none',
        }}
      >
        <UISubHeaderComponent
          mainPage="My SCR Overview"
          subPage="Employment"
          //copy="This is where all of your information is gathered. You can get a full overview of all the completed and outstanding details needed for your record."
          onDelete={() => {}}
          isViewMode={false}
          isCreatePolicy={false}
        />
        <div className="flex my-8 gap-2">
          {/* First column */}
          <div
            style={{
              height: 'calc(100vh - 20px)',
              overflow: 'auto',
              scrollbarWidth: 'none',
            }}
            className="flex flex-col w-8/12 gap-4"
          >
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'Current Employment Details'}
                isActive={false}
              >
                <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                  <div className="flex w-full gap-4">
                    <div className="w-6/12  ">
                      <UITextInput
                        placeholder={'Job Title'}
                        label={'Job Title'}
                        iconName={''}
                        value={userData && userData[2]?.jobTitle}
                        onChange={(e) => {
                          handleChange(3, 'jobTitle', e.target.value)
                        }}
                      />
                    </div>
                    <div className="w-6/12">
                      <UITextInput
                        placeholder={'Department'}
                        label={'Department'}
                        iconName={''}
                        value={userData && userData[2]?.department}
                        onChange={(e) => {
                          handleChange(3, 'department', e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex w-full gap-4">
                    <div className="w-6/12 ">
                      <UIDatePickerv
                        placeholderText={'Not Specified'}
                        title={'Start Date'}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(3, 'startDate', e.target.value)
                        }}
                        value={userData && userData[2]?.startDate}
                      />
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="w-6/12">
                      <UiSelect
                        onChange={(e: string) => {
                          handleChange(3, 'workStatus', e)
                        }}
                        value={userData && userData[2]?.workStatus}
                        options={[
                          { value: 'Full Time', label: 'Full Time' },
                          { value: 'Part Time', label: 'Part Time' },
                          { value: 'Term Time', label: 'Term Time' },
                          { value: 'Job Share', label: 'Job Share' },
                          { value: 'Casual', label: 'Casual' },
                          { value: 'Agency', label: 'Agency' },
                          { value: 'Contract', label: 'Contract' },
                        ]}
                        title={'Work Status'}
                      />
                    </div>
                  </div>
                </div>
              </AccordionItem>
            </Accordion>

            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'Previous Employment Details 1'}
                isActive={false}
              >
                <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                  <div className="flex w-full gap-4">
                    <div className="w-6/12  ">
                      <UITextInput
                        placeholder={'Job Title'}
                        label={'Job Title'}
                        iconName={''}
                        value={userData && userData[0]?.jobTitle}
                        onChange={(e) => {
                          handleChange(1, 'jobTitle', e.target.value)
                        }}
                      />
                    </div>
                    <div className="w-6/12">
                      <UITextInput
                        placeholder={'Department'}
                        label={'Department'}
                        iconName={''}
                        value={userData && userData[0]?.department}
                        onChange={(e) => {
                          handleChange(1, 'department', e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex w-full gap-4">
                    <div className="w-6/12 ">
                      <UIDatePickerv
                        placeholderText={'Not Specified'}
                        title={'Start Date'}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(1, 'startDate', e.target.value)
                        }}
                        value={userData && userData[0]?.startDate}
                      />
                    </div>
                    <div className="w-6/12">
                      <UIDatePickerv
                        placeholderText={'Not Specified'}
                        title={'End Date'}
                        value={userData && userData[0]?.endDate}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(1, 'endDate', e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="w-6/12">
                      <UiSelect
                        onChange={(e: string) => {
                          handleChange(1, 'workStatus', e)
                        }}
                        value={userData && userData[0]?.workStatus}
                        options={[
                          { value: 'Full Time', label: 'Full Time' },
                          { value: 'Part Time', label: 'Part Time' },
                          { value: 'Term Time', label: 'Term Time' },
                          { value: 'Job Share', label: 'Job Share' },
                          { value: 'Casual', label: 'Casual' },
                          { value: 'Agency', label: 'Agency' },
                          { value: 'Contract', label: 'Contract' },
                        ]}
                        title={'Work Status'}
                      />
                    </div>
                  </div>
                </div>
              </AccordionItem>
            </Accordion>
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'Previous Employment Details 2'}
                isActive={false}
              >
                <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                  <div className="flex w-full gap-4">
                    <div className="w-6/12  ">
                      <UITextInput
                        placeholder={'Job Title'}
                        label={'Job Title'}
                        iconName={''}
                        value={userData && userData[1]?.jobTitle}
                        onChange={(e) => {
                          handleChange(2, 'jobTitle', e.target.value)
                        }}
                      />
                    </div>
                    <div className="w-6/12">
                      <UITextInput
                        placeholder={'Department'}
                        label={'Department'}
                        iconName={''}
                        value={userData && userData[1]?.department}
                        onChange={(e) => {
                          handleChange(2, 'department', e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex w-full gap-4">
                    <div className="w-6/12 ">
                      <UIDatePickerv
                        placeholderText={'Not Specified'}
                        title={'Start Date'}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(2, 'startDate', e.target.value)
                        }}
                        value={userData && userData[1]?.startDate}
                      />
                    </div>
                    <div className="w-6/12">
                      <UIDatePickerv
                        placeholderText={'Not Specified'}
                        title={'End Date'}
                        value={userData && userData[1]?.endDate}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleChange(2, 'endDate', e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex w-full">
                    <div className="w-6/12">
                      <UiSelect
                        onChange={(e: string) => {
                          handleChange(2, 'workStatus', e)
                        }}
                        value={userData && userData[1]?.workStatus}
                        options={[
                          { value: 'Full Time', label: 'Full Time' },
                          { value: 'Part Time', label: 'Part Time' },
                          { value: 'Term Time', label: 'Term Time' },
                          { value: 'Job Share', label: 'Job Share' },
                          { value: 'Casual', label: 'Casual' },
                          { value: 'Agency', label: 'Agency' },
                          { value: 'Contract', label: 'Contract' },
                        ]}
                        title={'Work Status'}
                      />
                    </div>
                  </div>
                </div>
              </AccordionItem>
            </Accordion>
          </div>

          {/* Second column */}
          <div className="w-4/12">
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'Scorecard'}
                isActive={true}
                AccordionItemStyle={{
                  backgroundColor: 'rgba(230, 240, 243, 1)',
                }}
                AccordiontitleStyle={
                  'text-sm text-bluishGreen flex-1 font-semibold'
                }
                AccordionItemStyleContainer={{
                  backgroundColor: 'rgba(242, 247, 249, 1)',
                }}
                icon={'IconBarChartSquare'}
              >
                <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                  <div className="w-[160px] h-[160px]">
                    <CircularProgressbar
                      strokeWidth={5}
                      value={
                        calculateNonNullPercentage([
                          userData && userData[0]?.jobTitle,
                          userData && userData[0]?.department,
                          userData && userData[0]?.startDate,
                          userData && userData[0]?.endDate,
                          userData && userData[0]?.workStatus,
                          userData && userData[1]?.jobTitle,
                          userData && userData[1]?.department,
                          userData && userData[1]?.startDate,
                          userData && userData[1]?.endDate,
                          userData && userData[1]?.workStatus,
                          userData && userData[2]?.jobTitle,
                          userData && userData[2]?.department,
                          userData && userData[2]?.startDate,

                          userData && userData[2]?.workStatus,
                        ]).percentage
                      }
                      text={`${
                        calculateNonNullPercentage([
                          userData && userData[0]?.jobTitle,
                          userData && userData[0]?.department,
                          userData && userData[0]?.startDate,
                          userData && userData[0]?.endDate,
                          userData && userData[0]?.workStatus,
                          userData && userData[1]?.jobTitle,
                          userData && userData[1]?.department,
                          userData && userData[1]?.startDate,
                          userData && userData[1]?.endDate,
                          userData && userData[1]?.workStatus,
                          userData && userData[2]?.jobTitle,
                          userData && userData[2]?.department,
                          userData && userData[2]?.startDate,

                          userData && userData[2]?.workStatus,
                        ]).percentage
                      }%`}
                      styles={{
                        root: {},
                        path: {
                          stroke: calculateNonNullPercentage([
                            userData && userData[0]?.jobTitle,
                            userData && userData[0]?.department,
                            userData && userData[0]?.startDate,
                            userData && userData[0]?.endDate,
                            userData && userData[0]?.workStatus,
                            userData && userData[1]?.jobTitle,
                            userData && userData[1]?.department,
                            userData && userData[1]?.startDate,
                            userData && userData[1]?.endDate,
                            userData && userData[1]?.workStatus,
                          ]).color,
                          transition: 'stroke-dashoffset 0.5s ease 0s',
                        },
                        text: {
                          fill: '#013546',
                          fontSize: '24px',
                          fontWeight: 700,
                          lineHeight: 40,
                        },
                      }}
                    />
                  </div>
                  <div className="items-center justify-center flex">
                    <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                      {calculateNonNullPercentage(propertiesToCheck)
                        .percentage == 100
                        ? 'Well done you reached 100%'
                        : calculateNonNullPercentage(propertiesToCheck)
                              .percentage == 0
                          ? 'Make a start to improve your score'
                          : ' Great start! But there is still room for improvement'}
                    </p>
                  </div>
                  <Accordion defaultActiveIndex={0}>
                    <AccordionItem
                      onClick={() => console.log('Accordion')}
                      title={' Your score is broken down as follows:'}
                      isActive={false}
                      AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                      AccordiontitleStyle={
                        'text-xs font-semibold text-text4 leading-5 flex-1'
                      }
                      AccordionItemStyleContainer={{
                        backgroundColor: '#FFFFFF',
                      }}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={
                              calculateNonNullPercentage([
                                userData && userData[2]?.jobTitle,
                                userData && userData[2]?.department,
                                userData && userData[2]?.startDate,

                                userData && userData[2]?.workStatus,
                              ]).percentage
                            }
                            label={'Current Employment Details'}
                            stroke={
                              calculateNonNullPercentage([
                                userData && userData[2]?.jobTitle,
                                userData && userData[2]?.department,
                                userData && userData[2]?.startDate,

                                userData && userData[2]?.workStatus,
                              ]).color
                            }
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={
                              calculateNonNullPercentage([
                                userData && userData[0]?.jobTitle,
                                userData && userData[0]?.department,
                                userData && userData[0]?.startDate,
                                userData && userData[0]?.endDate,
                                userData && userData[0]?.workStatus,
                              ]).percentage
                            }
                            label={'Previous Employment Details 1'}
                            stroke={
                              calculateNonNullPercentage([
                                userData && userData[0]?.jobTitle,
                                userData && userData[0]?.department,
                                userData && userData[0]?.startDate,
                                userData && userData[0]?.endDate,
                                userData && userData[0]?.workStatus,
                              ]).color
                            }
                            strokeWidth={1.5}
                          />
                        </div>
                        <div className="mt-3">
                          <UIStaightlineProressBar
                            percentage={
                              calculateNonNullPercentage([
                                userData && userData[1]?.jobTitle,
                                userData && userData[1]?.department,
                                userData && userData[1]?.startDate,
                                userData && userData[1]?.endDate,
                                userData && userData[1]?.workStatus,
                              ]).percentage
                            }
                            label={'Previous Employment Details 2'}
                            stroke={
                              calculateNonNullPercentage([
                                userData && userData[1]?.jobTitle,
                                userData && userData[1]?.department,
                                userData && userData[1]?.startDate,
                                userData && userData[1]?.endDate,
                                userData && userData[1]?.workStatus,
                              ]).color
                            }
                            strokeWidth={1.5}
                          />
                        </div>
                      </div>
                    </AccordionItem>
                  </Accordion>
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
        <div className="bg-gray3 w-full h-[1px] my-3"></div>
        <div className="w-[33%] mt-6">
          <UIButton
            loading={isUpdateLoading}
            onClick={() => {
              if (userData) {
                updateProfileData(userData)
              }
            }}
            label="Update"
          />
        </div>
      </div>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenAlert}
        onClose={() => {
          setIsOpenAlert(false)
        }}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Save changes?
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Do you want to save changes before moving on?
            </p>
          </div>

          <button
            onClick={() => {
              if (userData) {
                updateProfileData(userData)
              }
              setIsOpenAlert(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Save changes
          </button>
          <button
            onClick={() => {
              setIsOpenAlert(false)
            }}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            {`Don't save`}
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Employment
